import React from 'react';
import styled from 'styled-components';
import PropTypes, { shape } from 'prop-types';
import AddModuleButton from '../atoms/add-module-button';
import ConfigurationInformations from './configuration_informations';
import ModuleSettings from './module_settings';
import LoadingSpinner from '../atoms/loading';
import { configurationModuleType, busExpansionType, rangeProductType, configurationStatuses, m172_ranges, pacdrive_ranges, edgeClusterHead } from '../constants';
import Configuration from '../models/Configuration';
import Device from '../models/Device'
import I10n from '../features/i10n';
import { appConfiguration } from '../utils/app-starter';
import MsxIcons from '../features/msx-icons';
import ConfigurationActionButton from '../atoms/configuration-action-button';
import EdgeCluster from './edge/edge_cluster';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

const ConfigurationContainer = styled(Row)`
  display: flex;
  flex-direction: row;
  @media(max-width: 800px) {
    flex-direction: column;
  }
`;

const GraphicalViewWrapper = styled.div`
  display: inline-block;
  white-space: nowrap;
  flex: 3 1 auto;
  position: relative;
  overflow-y: hidden;
`;

const GraphicalView = styled.div`
  box-sizing: content-box;
  flex: 1 1 100%;
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 60px 5px 50px 5px;
  overflow-y: hidden;
  overflow-x: auto;
  background-color: #fafafa;
  border-radius: 2px;
  box-shadow: inset 0 0 15px 1px rgba(0,0,0,0.1);
  height: 160px;
`;

const ButtonContainer = styled.div`
  display: inline-block;
  height: 160px;
  margin: 0 5px;
  vertical-align: bottom;
`;

const ButtonWrapper = styled.div`
  height: ${props => props.height ? `${props.height}px` : '100%'};
`;

const LoadingSpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: hidden;
  padding: 10px;
`;

const ConfigurationInformationsContainer = styled.div`
  flex: 0 0 300px;
  border: 1px solid #e7e6e6;
  @media (max-width: 800px) {
    flex: 1 0 auto;
  }
`;

const ActionsContainer = styled.div`
  position: absolute;
  top : 5px; right: 5px;
  display: flex;
  align-items: center;
`;

const IoTypeButtonWrapper = styled.div`
  margin-right: 5px;
  font-weight: lighter;
`;

const ModuleActionRow = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  color: #42B4E6;
  color: var(--se-secondary, #42B4E6);
  :hover {
    background-color: rgb(237, 237, 237);
  }
`;

const RemoveActionRow = styled(ModuleActionRow)`
  color: #DC0A0A;
`;

const ModuleActionText = styled.span`
  font-size: 16px;
  font-weight: 300;
  margin-left: 5px;
`;

const IO_MODULE_TYPE = 'IO_MODULE';
const EDGE_IO_QUESTION_TYPE = 'EDGE_IO_MODULE';

class EdgeConfigurationPreview extends React.Component {

  static propTypes = {
    configuration: shape(Configuration),
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    addModuleAccessory: PropTypes.func,
    addModuleAuxiliary: PropTypes.func,
    addModuleSensor: PropTypes.func,
    removeModuleAccessory: PropTypes.func,
    removeModuleAuxiliary: PropTypes.func,
    removeModuleSensor: PropTypes.func,
    removeModuleSparePart: PropTypes.func,
    setModuleWarranty: PropTypes.func,
    addDevices: PropTypes.func,
    addComModules: PropTypes.func,
    addCartridge: PropTypes.func,
    getAccessories: PropTypes.func,
    getModuleActions: PropTypes.func,
    changeSoftwareVersion: PropTypes.func,
    removeCartridge: PropTypes.func,
    duplicateModule: PropTypes.func,
    removeModule: PropTypes.func,
    replaceSelectedAdditionalDevice: PropTypes.func,
    replaceModule: PropTypes.func,
    updateModule: PropTypes.func,
    insertModulesBefore: PropTypes.func,
    insertModulesAfter: PropTypes.func,
    comModulesCategories: PropTypes.array,
    ioModulesCategories: PropTypes.array,
    ioModulesRemainingCriteria: PropTypes.object,
    comModulesRemainingCriteria: PropTypes.object,
    ioModulesSharedOptions: PropTypes.object,
    comModulesSharedOptions: PropTypes.object,
    cartridgesCategories: PropTypes.array,
    comModulesFailedRules: PropTypes.array,
    ioModulesFailedRules: PropTypes.array,
    cartridgesFailedRules: PropTypes.array,
    ioModulesDevicesFailedRules: PropTypes.object,
    comModulesDevicesFailedRules: PropTypes.object,
    cartridgesDevicesFailedRules: PropTypes.object,
    isLoading: PropTypes.bool,
    moduleActionsLoading: PropTypes.bool,
    accessoriesLoading: PropTypes.bool,
    canReplaceHead: PropTypes.bool,
    onAdjustRequested: PropTypes.func,
    pacdriveKits: PropTypes.object,
    allowSavedModifications: PropTypes.bool,
    showIoTypes: PropTypes.func,
    previewConfiguration: PropTypes.func,
    hasPowerSupplies: PropTypes.bool,
  }

  constructor(props) {
    super(props);
    this.state = {
      slotModuleSelected: null,
      typeModuleSelected: null,
      renderDimensions: false,
      selectedModuleCandidateAccessories: {},
      selectedModuleActions: {}
    }
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  get selectedModule() {
    return this.getModuleAtSlot(this.state.slotModuleSelected, this.state.typeModuleSelected);
  }

  getModuleAtSlot = (slot, moduleType) => {
    let mod;
    switch (moduleType) {
      case configurationModuleType.head_module:
        mod = this.props.configuration.headModule;
        break;
      case configurationModuleType.com_module:
        mod = this.props.configuration.comModules.find(m => m.slot === slot);
        break;
      case configurationModuleType.io_module:
        mod = this.props.configuration.ioModules.find(m => m.slot === slot);
        break;
      default:
        break;
    }
    return new Device(mod);
  }

  get canTooltipAppears() {
    try {
      return localStorage.getItem('tooltip-head-occurs') == null;
    } catch (error) {
      return true;
    }
  }

  refreshSelectedModuleAccessories = (moduleId) => {
    this.props.getAccessories(moduleId).then((accessoryCategories) => {
      this.updateStateIfMounted({ selectedModuleCandidateAccessories: accessoryCategories });
    }).catch((error) => {
    });
  }

  refreshSelectedModuleActions = (newSlotSelected, newSelectedType) => {
    if (newSlotSelected !== null && newSelectedType !== null) {
      this.props.getModuleActions(newSlotSelected, newSelectedType, true)
        .then(result => {
          if (result && !result.cancelled) {
            this.updateStateIfMounted({ selectedModuleActions: result });
          }
        })
        .catch(error => { throw error; });
    }
  }

  updateSelectedModule = (newSlotSelected, newSelectedType) => {
    if (newSlotSelected !== this.state.slotModuleSelected || newSelectedType !== this.state.typeModuleSelected) {
      this.updateStateIfMounted({
        slotModuleSelected: newSlotSelected,
        typeModuleSelected: newSelectedType,
        selectedModuleCandidateAccessories: {},
        moduleActions: {}
      });
      if (newSlotSelected !== null) {
        const modSelected = this.getModuleAtSlot(newSlotSelected, newSelectedType);
        if (modSelected) {
          this.refreshSelectedModuleAccessories(modSelected.id);
          this.refreshSelectedModuleActions(newSlotSelected, newSelectedType);
        }
      }
    }
  }

  renderModuleActions = () => {
    return (
      (this.props.moduleActionsLoading || this.props.isLoading) ?
        <LoadingSpinnerWrapper>
          <LoadingSpinner></LoadingSpinner>
        </LoadingSpinnerWrapper> :
        <>
          {configurationModuleType.head_module === this.state.typeModuleSelected ? <>
            {this.props.canReplaceHead &&
              <ModuleActionRow onClick={() => {
                this.handleReplaceRequested(false);
              }}>
                <MsxIcons size="nano" name="replace"></MsxIcons>
                <ModuleActionText>{I10n.get('module_setting.action.replace')}</ModuleActionText>
              </ModuleActionRow>
            }
            {this.canAdjust(this.selectedModule) &&
              <ModuleActionRow onClick={() => {
                this.props.onAdjustRequested(this.selectedModule);
              }}>
                <MsxIcons size="nano" name="pacdrive-adjust"></MsxIcons>
                <ModuleActionText>{I10n.get('module_setting.action.adjust')}</ModuleActionText>
              </ModuleActionRow>
            }
          </> : <>
            {this.canReplace(this.selectedModule) &&
              <ModuleActionRow onClick={() => {
                this.handleReplaceRequested(false);
              }}>
                <MsxIcons size="nano" name="replace"></MsxIcons>
                <ModuleActionText>{I10n.get('module_setting.action.replace')}</ModuleActionText>
              </ModuleActionRow>
            }
            {this.canDuplicate() &&
              <ModuleActionRow onClick={() => { this.handleDuplicate(false); }}>
                <MsxIcons size="nano" name="copy"></MsxIcons>
                <ModuleActionText>{(edgeClusterHead === this.selectedModule?.productType) ? I10n.get('module_setting.action.duplicate_cluster') : I10n.get('module_setting.action.duplicate')} </ModuleActionText>
              </ModuleActionRow>
            }
            {this.canInsertLeft(this.selectedModule) &&
              <ModuleActionRow onClick={() => { this.onInsertModuleLeftRequested(false); }}>
                <MsxIcons size="nano" name="add"></MsxIcons>
                <ModuleActionText>{I10n.get('module_setting.action.insert_left')}</ModuleActionText>
              </ModuleActionRow>
            }
            {this.canInsertRight(this.selectedModule) &&
              <ModuleActionRow onClick={() => { this.onInsertModuleRightRequested(false); }}>
                <MsxIcons size="nano" name="add"></MsxIcons>
                <ModuleActionText>{I10n.get('module_setting.action.insert_right')}</ModuleActionText>
              </ModuleActionRow>
            }
            {this.canRemove(this.selectedModule) &&
              <RemoveActionRow onClick={() => { this.handleRemove(); }}>
                <MsxIcons size="nano" name="delete"></MsxIcons>
                <ModuleActionText>{I10n.get('module_setting.action.remove')}</ModuleActionText>
              </RemoveActionRow>
            }</>}
        </>
    );
  }

  handleDuplicateConfiguration = (isSaved, callback, promptClearPowerSupply = false) => {
    if (isSaved && !this.props.allowSavedModifications) {

      const modalTitle = promptClearPowerSupply ? 'modal.change_saved_configuration_with_power_supply.title' : 'modal.change_saved_configuration.title';
      const modalBody = promptClearPowerSupply ? 'modal.change_saved_configuration_with_power_supply.body' : 'modal.change_saved_configuration.body';

      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            callback();
          },
          title: I10n.get(modalTitle),
          text: I10n.get(modalBody),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      if (this.props.hasPowerSupplies && promptClearPowerSupply) {
        this.props.openModal({
          modalType: 'confirmation',
          modalProps: {
            onCancel: () => { this.props.closeModal(); },
            onSubmit: () => {
              this.props.closeModal();
              callback();
            },
            title: I10n.get('screen.reset_power_supply.modal.title'),
            text: I10n.get('screen.reset_power_supply.modal.body'),
            cancelText: I10n.get('app.action.cancel'),
            submitText: I10n.get('app.action.continue'),
          }
        });
      } else {
        callback();
      }
    }
  }

  onInsertClusterRequested = (slot) => {
    this.props.openModal({
      modalType: 'insert_module',
      modalProps: {
        insertionSlot: slot + 1,
        incrementSlot: true,
        moduleType: IO_MODULE_TYPE,
        questionType: EDGE_IO_QUESTION_TYPE,
        onInsert: (moduleId, quantity) => { this.handleInsertCluster(moduleId, quantity, slot)},
      },
    });
  }

  renderByBlocks = (maxModuleHeight) => {
    const configuration = this.props.configuration;
    const blocks = configuration.blocks();
    const totalActiveModulesCount = blocks.reduce((total, block) => total + block.countableModules().length, 0);
    const isTotalLimitReached = totalActiveModulesCount >= configuration.rangeInfo.maxTotalIOModules;

    return (
      blocks.map((block, blockIdx) => {
        return (
          <EdgeCluster
            key={blockIdx}
            block={block}
            blockIdx={blockIdx}
            blocks={configuration.blocks()}
            renderDimensions={this.state.renderDimensions}
            maxModuleHeight={maxModuleHeight}
            headModule={configuration.headModule}
            typeModuleSelected={this.state.typeModuleSelected}
            slotModuleSelected={this.state.slotModuleSelected}
            updateSelectedModule={this.updateSelectedModule}
            renderModuleActions={this.renderModuleActions}
            wrapperElement={this.wrapperElement}
            isLastCluster={blockIdx === (blocks.length - 1) && !isTotalLimitReached}
            onInsertModuleRightRequested={this.onInsertModuleRightRequested}
            renderAddIOButton={(maxModuleHeight) => this.renderAddIOButton(maxModuleHeight, totalActiveModulesCount)}
            renderClusterAddIOButton={this.renderClusterAddIOButton}
            rangeInfo={configuration.rangeInfo}
            totalActiveModulesCount={totalActiveModulesCount}
            isTotalLimitReached={isTotalLimitReached}
          >
          </EdgeCluster>
        );
      })
    );
  }
  renderAddIOButton = (maxModuleHeight) => {

    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    const isDisabled = this.props.ioModulesCategories.filter(c => (c?.references || []).length).length === 0;
    const cmp = (
      <AddModuleButton
        title={this.buildFailedRulesTooltip('IO')}
        disabled={isDisabled}
        onClick={e => {
          e.preventDefault();
          this.handleDuplicateConfiguration(isSaved, () => {
            this.props.openModal({
              modalType: 'add_module',
              modalProps: {
                addDevices: this.handleAddIOModules,
                categories: this.props.ioModulesCategories,
                remainingCriteria: this.props.ioModulesRemainingCriteria,
                sharedOptions: this.props.ioModulesSharedOptions,
                moduleType: configurationModuleType.io_module,
                questionType: this.props.configuration?.rangeInfo?.ioModulesQuestionCategory
              },
            });
          }, true);
        }}
      >+</AddModuleButton>
    );
    const lastDevice = this.props.configuration.ioModules
      .reduce((previous, current) => current.slot > previous.slot ? current : previous, new Device({}));
    return this.renderAddButton(cmp, lastDevice, maxModuleHeight);
  }
  renderClusterAddIOButton = (slot, lastModule, maxModuleHeight, isClusterFull) => {
    const specialOnClick = (e) => {
      this.onInsertClusterRequested(slot);
    };
    const cmp = (
      <AddModuleButton
        title={this.buildFailedRulesTooltip('IO')}
        disabled={isClusterFull}
        onClick={specialOnClick}
      >+</AddModuleButton>
    );

    return this.renderAddButton(cmp, lastModule, maxModuleHeight);
  }

  /**
   * Render the add button if modules gathering is done.
   */
  renderAddButton = (addBtnComponent, lastDevice, maxModuleHeight) => {
    const realHeight = lastDevice.height ? lastDevice.height : 0;
    const buttonHeight = this.computeModuleHeight(realHeight, maxModuleHeight);
    return (
      <ButtonContainer>
        {this.props.isLoading && (
          <LoadingSpinnerWrapper>
            <LoadingSpinner width={'10px'} height={'10px'}></LoadingSpinner>
          </LoadingSpinnerWrapper>
        )}
        {!this.props.isLoading && (
          <ButtonWrapper height={buttonHeight}>{addBtnComponent}</ButtonWrapper>
        )}
      </ButtonContainer>
    );
  }

  computeModuleHeight = (realHeight, maxModuleHeight) => {
    const heightRatio = Math.ceil(100 * realHeight / maxModuleHeight) / 100;
    return 160 * (heightRatio ? heightRatio : 1);
  }

  computeModuleWidth = (realWidth, realHeight, newHeight) => {
    const aspectRatio = realWidth / realHeight;
    return newHeight * (aspectRatio ? aspectRatio.toFixed(2) : 1);
  }

  buildFailedRulesTooltip = (buttonType) => {
    let failedRulesToDisplay = [];
    let failedRulesString = '';
    switch (buttonType) {
      case 'IO':
        failedRulesToDisplay = this.props.ioModulesFailedRules;
        break;
      case 'COM':
        failedRulesToDisplay = this.props.comModulesFailedRules;
        break;
      default:
        break;
    }

    failedRulesToDisplay.forEach(rule => {
      failedRulesString += (I10n.get(rule.name, 'data', { full: true }) + '\n');
    });

    return failedRulesString;
  }

  hasCartridges = () => {
    return this.state.typeModuleSelected === configurationModuleType.head_module;
  }

  hasConnectionType = () => {
    return this.selectedModule.relatedConnectionDevices?.length > 0;
  }

  hasFuse = () => {
    return Object.values(this.selectedModule.relatedFuseDevices || {}).length > 0;
  }

  hasSlottedAdditionalDevices = () => {
    return this.selectedModule.slottedAdditionalDevices?.length > 0;
  }

  canHandleCartridgeActions = () => {
    return !this.props.isLoading && this.hasCartridges();
  }

  canShowScreenAccessories = (device) => {
    return this.state.typeModuleSelected === configurationModuleType.head_module && m172_ranges.includes(device.rangeOfProduct);
  }

  canShowSparePartAccessories = (device) => {
    return this.state.typeModuleSelected === configurationModuleType.head_module && pacdrive_ranges.includes(device.rangeOfProduct);
  }

  canDuplicate = () => {
    return !this.props.isLoading && !this.props.moduleActionsLoading && this.state.selectedModuleActions.canDuplicate;
  }

  canRemove = (device) => {
    return !this.props.isLoading
      && !this.props.moduleActionsLoading
      && this.state.typeModuleSelected !== configurationModuleType.head_module
      && (device.busExpansionType !== busExpansionType.none
        || device.isPowerSupplier()
        || (this.state.selectedModuleActions && this.state.selectedModuleActions.canRemove === true));
  }

  canInsertLeft = (device) => {
    if (this.props.isLoading || this.props.moduleActionsLoading) return false;

    if (this.props.configuration.hasMasterValidationError()) return false;

    const comModulesLength = (this.props.configuration.comModules || []).length;
    const ioModulesLength = (this.props.configuration.ioModules || []).length;
    const rangeInfo = this.props.configuration.rangeInfo;

    if (this.state.typeModuleSelected === configurationModuleType.io_module) {
      return !busExpansionType.isReceiver(device.busExpansionType) &&
        rangeInfo.maxTotalIOModules + rangeInfo.maxIOModuleBlocks > ioModulesLength
        && this.state.selectedModuleActions && this.state.selectedModuleActions.canInsertBefore === true;
    } else {
      return comModulesLength > 0 && device.slot < comModulesLength &&
        !busExpansionType.isTransmitter(device.busExpansionType) &&
        rangeInfo.maxComModules > comModulesLength
        && this.state.selectedModuleActions && this.state.selectedModuleActions.canInsertAfter === true;
    }
  }

  canInsertRight = (device) => {
    if (this.props.isLoading || this.props.moduleActionsLoading) return false;

    if (this.props.configuration.hasMasterValidationError()) return false;

    const comModulesLength = (this.props.configuration.comModules || []).length;
    const ioModulesLength = (this.props.configuration.ioModules || []).length;
    const rangeInfo = this.props.configuration.rangeInfo;

    if (this.state.typeModuleSelected === configurationModuleType.com_module) {
      return !busExpansionType.isReceiver(device.busExpansionType) &&
        rangeInfo.maxComModules > comModulesLength
        && this.state.selectedModuleActions && this.state.selectedModuleActions.canInsertBefore === true;
    } else {
      return ioModulesLength > 0 && device.slot < ioModulesLength &&
        !busExpansionType.isTransmitter(device.busExpansionType) &&
        rangeInfo.maxTotalIOModules + rangeInfo.maxIOModuleBlocks > ioModulesLength
        && this.state.selectedModuleActions && this.state.selectedModuleActions.canInsertAfter === true;
    }
  }

  canReplace = (device) => {
    return (!this.props.isLoading
      && !this.props.moduleActionsLoading
      && ((device.busExpansionType === busExpansionType.none
        && this.state.selectedModuleActions
        && this.state.selectedModuleActions.canReplace === true)
        || (device.moduleType === configurationModuleType.head_module && this.props.canReplaceHead))
    );
  }

  canAdjust = (device) => {
    const deviceKits = this.props.pacdriveKits[device.id] || {};
    return (!this.props.isLoading
      && !this.props.moduleActionsLoading
      && Object.keys(deviceKits).length > 0
    );
  }

  canShowSoftwareVersion = (device) => {
    return device.moduleType === configurationModuleType.head_module
      && this.props.configuration.rangeInfo.productType === rangeProductType.plc
      && device?.possibleSoftwareVersions?.length > 0;
  }

  handleAddIOModules = (referenceID, quantity) => {

    this.props.addDevices(referenceID, quantity).then(() => {
      const slot = this.state.slotModuleSelected;
      const moduleType = this.state.typeModuleSelected;
      this.refreshSelectedModuleActions(slot, moduleType);
    });
  }

  handleAddComModules = (referenceID, quantity) => {

    this.props.addComModules(referenceID, quantity).then(() => {
      const slot = this.state.slotModuleSelected;
      const moduleType = this.state.typeModuleSelected;
      this.refreshSelectedModuleActions(slot, moduleType);
    });
  }

  duplicateModule = (slot, moduleType, closeModuleSettings) => {
    this.props.duplicateModule(slot, moduleType).then(() => {
      let newSelectedSlot = null;
      if (moduleType === configurationModuleType.io_module) {
        newSelectedSlot = this.props.configuration.ioModules.reduce((a, b) => a.slot > b.slot ? a.slot : b.slot, 0);
      } else {
        newSelectedSlot = this.props.configuration.comModules.reduce((a, b) => a.slot > b.slot ? a.slot : b.slot, 0);
      }
      if (closeModuleSettings) {
        this.updateSelectedModule(null, null);

      } else {
        this.updateSelectedModule(newSelectedSlot, moduleType);
      }
    }).catch(error => { });
  }

  handleDuplicate = (closeModuleSettings = false) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.handleDuplicateConfiguration(isSaved, () => {
      this.duplicateModule(slot, moduleType, closeModuleSettings);
    }, true);
  }

  formatConnectedIslandsText = (connectedIslands) => {
    let text = '\n\n';
    connectedIslands.forEach(islandWithProtocol => {
      text += `${islandWithProtocol.islandName} (${islandWithProtocol.protocolName})\n`;
    });
    return text;
  }

  islandsConnectedToModule = (module) => {
    const islandsWithProtocols = [];
    const configurationPLC = this.props.configuration.headModule;
    module.masterProtocols.forEach((protocol) => {
      const protocolName = protocol.name;
      const islandsConnectedWithProtocol =
        this.props.configuration
          .getIslandsConnectedWithProtocol(protocol.name);

      islandsConnectedWithProtocol.forEach(island => {
        if (configurationPLC.masterProtocols.filter(islandProtocol => islandProtocol.name !== protocolName).length > 0) {
          islandsWithProtocols.push({ islandName: island.getName(), protocolName });
        }
      });
    });

    return islandsWithProtocols;
  }

  removeModule = () => {
    const islandsConnectedToModule =
      this.islandsConnectedToModule(this.selectedModule);
    if (islandsConnectedToModule.length > 0) {
      this.props.openModal({
        modalType: 'information',
        modalProps: {
          onButtonClick: () => { this.props.closeModal(); },
          title: '',
          text: I10n.getAndReplace('modal.error.island_attached_to_device.body',
            this.formatConnectedIslandsText(islandsConnectedToModule)),
          buttonText: I10n.get('app.action.close'),
        }
      });
    } else {
      let modalBody = I10n.get('module_setting.remove.modal.body');
      if (this.selectedModule.busExpansionType !== busExpansionType.none) {
        modalBody = I10n.get('module_setting.remove.modal.body_multiple');
      } else if (this.selectedModule.isPowerSupplier()) {
        modalBody = I10n.get('module_setting.remove.modal.body_power_supply');
      }
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            this.props.removeModule(this.state.slotModuleSelected, this.state.typeModuleSelected, true);
            this.updateSelectedModule(null, null);
            this.props.closeModal()
          },
          title: I10n.get('module_setting.remove.modal.title'),
          text: modalBody,
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.confirm'),
        }
      });
    }
  }

  handleRemove = () => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    this.handleDuplicateConfiguration(isSaved, () => {
      this.removeModule();
    }, true);
  }

  handleRemoveCartridgeRequested = (slot, cartridge) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    const islandsConnectedToCartridge = this.islandsConnectedToModule(cartridge);
    this.handleDuplicateConfiguration(isSaved, () => {
      if (islandsConnectedToCartridge.length > 0) {
        this.props.openModal({
          modalType: 'information',
          modalProps: {
            onButtonClick: () => { this.props.closeModal(); },
            title: '',
            text: I10n.getAndReplace('modal.error.island_attached_to_device.body',
              this.formatConnectedIslandsText(islandsConnectedToCartridge)),
            buttonText: I10n.get('app.action.close'),
          }
        });
      } else {
        this.props.removeCartridge(slot);
      }
    }, true);
  }

  _changeSoftwareVersion = (newSoftwareVersion) => {
    this.props.changeSoftwareVersion(newSoftwareVersion);
  }

  handleSoftwareVersionChange = (newSoftwareVersion) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    this.handleDuplicateConfiguration(isSaved, () => {
      this._changeSoftwareVersion(newSoftwareVersion);
    }, false);
  }

  replaceModule = (closeModuleSettings) => {
    const moduleType = this.state.typeModuleSelected;
    const islandsConnectedToModule =
      this.islandsConnectedToModule(this.selectedModule);
    if (islandsConnectedToModule.length > 0 && moduleType !== configurationModuleType.head_module) {
      this.props.openModal({
        modalType: 'information',
        modalProps: {
          onButtonClick: () => { this.props.closeModal(); },
          title: '',
          text: I10n.getAndReplace('modal.error.island_attached_to_device.body',
            this.formatConnectedIslandsText(islandsConnectedToModule)),
          buttonText: I10n.get('app.action.close'),
        }
      });
    } else {
      if (moduleType === configurationModuleType.head_module) {
        this.props.openModal({
          modalType: 'replace_head',
          modalProps: {
            selectedHead: this.selectedModule,
            onReplaceHead: (moduleId) => { this.handleReplace(moduleId, closeModuleSettings) },
          },
        });

      } else {
        this.props.openModal({
          modalType: 'replace_module',
          modalProps: {
            replacementSlot: this.state.slotModuleSelected,
            moduleType: this.state.typeModuleSelected,
            questionType: this.modaleReplaceQuestionType,
            onReplace: (moduleId) => { this.handleReplace(moduleId, closeModuleSettings) },
          },
        });
      }
    }
  }

  handleReplaceRequested = (closeModuleSettings = false) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    this.handleDuplicateConfiguration(isSaved, () => {
      this.replaceModule(closeModuleSettings);
    }, true);
  }

  handleReplace = (referenceID, closeModuleSettings = false) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;

    return this.props.replaceModule(slot, moduleType, referenceID).then((success) => {
      if (closeModuleSettings) {
        this.updateSelectedModule(null, null);

      } else {
        this.refreshSelectedModuleAccessories(referenceID);
        this.refreshSelectedModuleActions(slot, moduleType);
      }
    });
  }

  handleUpdate = (module) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;

    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    this.handleDuplicateConfiguration(isSaved, () => {
      this.props.updateModule(slot, moduleType, module);
    }, true)
  }

  changeSlottedAdditionalDevice = (layer, selectedDevice) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.props.replaceSelectedAdditionalDevice(slot, moduleType, layer, selectedDevice);
  }

  handleSlottedAdditionalDeviceChange = (layer, selectedDevice) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    this.handleDuplicateConfiguration(isSaved, () => {
      this.changeSlottedAdditionalDevice(layer, selectedDevice);
    }, true);
  }

  insertModulesBefore = (slot, moduleType, reference, quantity, closeModuleSettings) => {
    return this.props.insertModulesBefore(slot, moduleType, reference, quantity)
      .then((success) => {
        if (closeModuleSettings) {
          this.updateSelectedModule(null, null);
        } else {
          this.updateSelectedModule(slot + quantity, moduleType)
        }
      })
      .catch((error) => { });
  }

  insertModulesAfter = (slot, moduleType, reference, quantity, closeModuleSettings) => {
    return this.props.insertModulesAfter(slot, moduleType, reference, quantity)
      .then((success) => {
        if (closeModuleSettings) {
          this.updateSelectedModule(null, null);
        } else {
          this.refreshSelectedModuleActions(slot, moduleType);
        }
      })
      .catch((error) => { });
  }

  handleInsertLeft = (reference, quantity, closeModuleSettings = false) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;

    if (moduleType === configurationModuleType.io_module) {
      return this.insertModulesBefore(slot, moduleType, reference, quantity, closeModuleSettings);
    } else if (moduleType === configurationModuleType.com_module) {
      return this.insertModulesAfter(slot, moduleType, reference, quantity, closeModuleSettings);
    } else {
      return this.insertModulesBefore(slot, configurationModuleType.com_module, reference, quantity, closeModuleSettings);
    }

  }

  handleInsertRight = (reference, quantity, closeModuleSettings = false) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;

    if (moduleType === configurationModuleType.io_module) {
      return this.insertModulesAfter(slot, moduleType, reference, quantity, closeModuleSettings);
    } else if (moduleType === configurationModuleType.com_module) {
      return this.insertModulesBefore(slot, moduleType, reference, quantity, closeModuleSettings);
    } else {
      return this.insertModulesBefore(slot, configurationModuleType.io_module, reference, quantity, closeModuleSettings);
    }

  }

  handleInsertCluster = (reference, quantity, slot) => {
    return this.insertModulesAfter(slot, "IO_MODULE", reference, quantity, false);
  }

  get modaleInsertLeftSlot() {
    const slot = this.state.slotModuleSelected;
    return this.state.typeModuleSelected === configurationModuleType.io_module ? slot : slot + 1;
  }
  get modaleInsertRightSlot() {
    const slot = this.state.slotModuleSelected;
    return this.state.typeModuleSelected === configurationModuleType.com_module ? slot : slot + 1;
  }

  get modaleInsertLeftModuleType() {
    const moduleType = this.state.typeModuleSelected;
    return moduleType === configurationModuleType.head_module ? configurationModuleType.com_module : moduleType;
  }
  get modaleInsertRightModuleType() {
    const moduleType = this.state.typeModuleSelected;
    return moduleType === configurationModuleType.head_module ? configurationModuleType.io_module : moduleType;
  }

  get modaleInsertLeftQuestionType() {
    const moduleType = this.state.typeModuleSelected;
    return moduleType === configurationModuleType.com_module ? configurationModuleType.com_module : this.props.configuration?.rangeInfo?.ioModulesQuestionCategory;
  }

  get modaleInsertRightQuestionType() {
    const moduleType = this.state.typeModuleSelected;
    return moduleType === configurationModuleType.com_module ? configurationModuleType.com_module : this.props.configuration?.rangeInfo?.ioModulesQuestionCategory;
  }

  get modaleReplaceQuestionType() {
    const moduleType = this.state.typeModuleSelected;
    if (moduleType === configurationModuleType.io_module) {
      return this.props.configuration?.rangeInfo?.ioModulesQuestionCategory;
    } else if (moduleType === configurationModuleType.com_module) {
      return configurationModuleType.com_module
    }

    return '';
  }

  setModuleWarranty = (newWarranty) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.props.setModuleWarranty(slot, moduleType, newWarranty);
  }

  addModuleAccessory = (newAccessory) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.props.addModuleAccessory(slot, moduleType, newAccessory);
  }

  addModuleAuxiliary = (newAccessory) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.props.addModuleAuxiliary(slot, moduleType, newAccessory);
  }

  addModuleSensor = (newAccessory) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.props.addModuleSensor(slot, moduleType, newAccessory);
  }

  addModuleSparePart = (newAccessory) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.props.addModuleSparePart(slot, moduleType, newAccessory);
  }

  removeModuleAccessory = (accessory) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.props.removeModuleAccessory(slot, moduleType, accessory);
  }

  removeModuleAuxiliary = (accessory) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.props.removeModuleAuxiliary(slot, moduleType, accessory);
  }

  removeModuleSensor = (accessory) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.props.removeModuleSensor(slot, moduleType, accessory);
  }

  removeModuleSparePart = (accessory) => {
    const slot = this.state.slotModuleSelected;
    const moduleType = this.state.typeModuleSelected;
    this.props.removeModuleSparePart(slot, moduleType, accessory);
  }


  /**
   * Open the add accessories modal. The candidate accessories must be provided.
   * @param {*} candidateAccessories
   */
  onAddAccessoriesRequested = (candidateAccessories, accessoryType) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    this.handleDuplicateConfiguration(isSaved, () => {
      this.props.openModal({
        modalType: 'add_accessories',
        modalProps: {
          accessoryType,
          candidateAccessories,
          addModuleAccessory: this.addModuleAccessory,
          addModuleAuxiliary: this.addModuleAuxiliary,
          addModuleSensor: this.addModuleSensor,
          addModuleSparePart: this.addModuleSparePart,
          setModuleWarranty: this.setModuleWarranty
        },
      });
    }, false);
  }

  onInsertModuleLeftRequested = (closeModuleSettings) => {
    this.props.openModal({
      modalType: 'insert_module',
      modalProps: {
        insertionSlot: this.modaleInsertLeftSlot,
        incrementSlot: true,
        moduleType: this.modaleInsertLeftModuleType,
        questionType: this.modaleInsertLeftQuestionType,
        onInsert: (moduleId, quantity) => { this.handleInsertLeft(moduleId, quantity, closeModuleSettings) },
      },
    });
  }

  onInsertModuleRightRequested = (closeModuleSettings) => {
    this.props.openModal({
      modalType: 'insert_module',
      modalProps: {
        insertionSlot: this.modaleInsertRightSlot,
        incrementSlot: true,
        moduleType: this.modaleInsertRightModuleType,
        questionType: this.modaleInsertRightQuestionType,
        onInsert: (moduleId, quantity) => { this.handleInsertRight(moduleId, quantity, closeModuleSettings) },
      },
    });
  }

  setWrapperRef = element => {
    this.wrapperElement = element;
  };

  render = () => {
    const config = this.props.configuration;
    const maxModuleHeight = config.maxModuleHeight();
    const selectedModule = this.selectedModule;
    const hasSelectedModule = !!selectedModule && this.state.slotModuleSelected !== null;
    const isSaved = config.status === configurationStatuses.finished;
    return (
      <Container>
        <ConfigurationContainer>
          <GraphicalViewWrapper>
            <ActionsContainer>
              <IoTypeButtonWrapper>
              <ConfigurationActionButton 
                title={"screen.graphical_editor.param_button"} 
                width={30} 
                height={30}  
                onClick={() => {
                  const isSaved = this.props.configuration.status === configurationStatuses.finished;

                  this.handleDuplicateConfiguration(isSaved, () => {
                    this.props.openModal({
                      modalType: 'terminal-blocks-settings',
                      modalProps: {}
                    });
                  }, true);
                }}
              >
                <MsxIcons name="settings" size="xsmall"></MsxIcons>
              </ConfigurationActionButton>

              </IoTypeButtonWrapper>
              <IoTypeButtonWrapper>
                <ConfigurationActionButton title={I10n.get('screen.config_editor.3d_viewer.button')} width={30} height={30} onClick={() => {
                  this.props.show3DViewer();
                }}>{I10n.get('screen.config_editor.3d_viewer.button')}</ConfigurationActionButton>
              </IoTypeButtonWrapper>
              <IoTypeButtonWrapper>
                <ConfigurationActionButton title={I10n.get('screen.config_editor.preview.io_types')} width={30} height={30} onClick={() => {
                  this.props.showIoTypes();
                }}>{I10n.get('screen.config_editor.preview.io_types.button')}</ConfigurationActionButton>
              </IoTypeButtonWrapper>
              <ConfigurationActionButton title={I10n.get('screen.config_editor.preview')} width={30} height={30} onClick={() => {
                this.props.previewConfiguration();
              }}><MsxIcons name="expand" size="nano"></MsxIcons></ConfigurationActionButton>
            </ActionsContainer>
            <GraphicalView ref={this.setWrapperRef}>
              {this.renderByBlocks(maxModuleHeight)}
            </GraphicalView>
          </GraphicalViewWrapper>
          <ConfigurationInformationsContainer>
            <ConfigurationInformations
              configuration={config}
              onConsumptionDisplayChange={(showBuses) => {
                this.setState({ renderPowerSupplyBuses: showBuses });
              }}
              onRenderDimensionsChange={(showDimensions) => {
                this.setState({ renderDimensions: showDimensions });
              }}
            >
            </ConfigurationInformations>
          </ConfigurationInformationsContainer>
        </ConfigurationContainer>
        {hasSelectedModule &&
          <ModuleSettings
            module={selectedModule}
            rangeInfo={config.rangeInfo}
            cartridges={config.cartridges}
            cartridgeMaxQuantity={config.headModule.maxCartridges}
            hasCartridges={this.hasCartridges}
            hasConnectionType={this.hasConnectionType}
            hasFuse={this.hasFuse}
            hasSlottedAdditionalDevices={this.hasSlottedAdditionalDevices}
            canHandleCartridgeActions={this.canHandleCartridgeActions}
            canShowScreenAccessories={this.canShowScreenAccessories}
            canShowSparePartAccessories={this.canShowSparePartAccessories}
            onAddCartridgeRequested={(slot) => {
              this.handleDuplicateConfiguration(isSaved, () => {
                this.props.openModal({
                  modalType: 'insert_module',
                  modalProps: {
                    insertionSlot: slot,
                    incrementSlot: true,
                    moduleType: configurationModuleType.cartridges,
                    questionType: configurationModuleType.cartridges,
                    onInsert: (mod) => { this.props.addCartridge(mod, slot) },
                  },
                });
              }, true);
            }}
            onAddAccessoriesRequested={this.onAddAccessoriesRequested}
            onRemoveCartridgeRequested={this.handleRemoveCartridgeRequested}
            onReplaceModuleRequested={this.handleReplaceRequested}
            onAdjustRequested={this.props.onAdjustRequested}
            onInsertModuleLeftRequested={this.onInsertModuleLeftRequested}
            onInsertModuleRightRequested={this.onInsertModuleRightRequested}
            canDuplicate={this.canDuplicate}
            onDuplicate={this.handleDuplicate}
            canRemove={this.canRemove}
            canAdjust={this.canAdjust}
            canInsertLeft={this.canInsertLeft}
            canInsertRight={this.canInsertRight}
            canReplace={this.canReplace}
            onReplace={this.handleReplace}
            onUpdate={this.handleUpdate}
            onSlottedAdditionalDeviceChange={this.handleSlottedAdditionalDeviceChange}
            canShowSoftwareVersion={this.canShowSoftwareVersion}
            onSoftwareVersionChange={this.handleSoftwareVersionChange}
            onRemove={this.handleRemove}
            onClose={() => {
              this.updateSelectedModule(null, null);
            }}
            isLoading={this.props.isLoading}
            moduleActionsLoading={this.props.moduleActionsLoading}
            removeModuleWarranty={() => { this.setModuleWarranty(null) }}
            removeModuleAccessory={this.removeModuleAccessory}
            removeModuleAuxiliary={this.removeModuleAuxiliary}
            removeModuleSensor={this.removeModuleSensor}
            removeModuleSparePart={this.removeModuleSparePart}
            selectedModuleCandidateAccessories={this.state.selectedModuleCandidateAccessories}
            preferredProductReference={appConfiguration.preferredProductReference}
            accessoriesLoading={this.props.accessoriesLoading}
            starterType={this.props.configuration.starterType}
          >
          </ModuleSettings>
        }
      </Container>
    );
  }
}

export default EdgeConfigurationPreview;
